// extracted by mini-css-extract-plugin
module.exports = {"promoCard":"promoCard_promoCard__17ZZz","inner":"promoCard_inner__22Pcr"};